<span class="font-medium-title-large">Nutzer einladen</span>

<form [formGroup]="form" class="align-self-stretch flex-c gap-16">
  <div class="flex-r gap-16">
    <div class="input-simple flex-1-1-0">
      <label for="email" class="input-label">
        E-Mail{{ fieldRequired(form.get('email')) ? '*' : '' }}
      </label>
      <input
        type="email"
        id="email"
        name="email"
        class="input-field"
        placeholder="E-Mail Adresse"
        formControlName="email" />
      <app-error-message [formField]="form.get('email')"></app-error-message>
    </div>
  </div>

  <div class="input-select align-self-stretch">
    <div class="input-label" for="ownerId">
      Rolle{{ fieldRequired(form.get('role')) ? '*' : '' }}
    </div>
    <p-select
      appendTo="body"
      formControlName="role"
      [options]="roleOptions"
      optionLabel="label"
      optionValue="value"
      placeholder="Rolle auswählen...">
    </p-select>
    <app-error-message [formField]="form.get('role')"></app-error-message>
  </div>
</form>

<div class="flex-r gap-16 justify-center padding-top-16">
  <button
    type="button"
    class="inwi-icon-text-button-large-secondary"
    (click)="onCancel()">
    <div class="button-content">
      <div class="button-icon">
        <i class="fa-regular fa-times"></i>
      </div>
      <div class="button-text">Abbrechen</div>
    </div>
  </button>
  <button
    type="button"
    class="inwi-icon-text-button-large-primary"
    (click)="onInvite()"
    [disabled]="form.invalid || isLoading">
    <div class="button-content">
      <div class="button-icon">
        <i
          class="fa-regular"
          [ngClass]="isLoading ? 'fa-rotate' : 'fa-paper-plane'"></i>
      </div>
      <div class="button-text">
        {{ isLoading ? 'Wird gesendet...' : 'Einladen' }}
      </div>
    </div>
  </button>
</div>
